import { dispatchError, dispatchLoading, dispatchSuccess } from '../utils';
import { GET_FASILITASWISATA, API_TIMEOUT } from '../utils/constant';

import axios from 'axios';

export const GET_LIST_FASILITAS_DESTINASI = 'GET_LIST_FASILITAS_DESTINASI';

export const getFasilitasDestinasi = () => {
  return (dispatch) => {
    dispatchLoading(dispatch, GET_LIST_FASILITAS_DESTINASI);

    axios({
      method: 'get',
      url: GET_FASILITASWISATA,
      timeout: API_TIMEOUT,
    })
      .then((response) => {
        if (response.status !== 200) {
          // ERROR
          dispatchError(dispatch, GET_LIST_FASILITAS_DESTINASI, 'error');
        } else {
          //BERHASIL

          dispatchSuccess(
            dispatch,
            GET_LIST_FASILITAS_DESTINASI,
            response.data.data ? response.data.data : []
          );
        }
      })
      .catch((error) => {
        // ERROR
        dispatchError(dispatch, GET_LIST_FASILITAS_DESTINASI, error);
        alert(error);
      });
  };
};
